/*********************************************************************
 * 
 * WARNING: This shader manager class is automatically generated, any manual 
 * edits will be lost.
 * Last generated: 2020-04-03T14:33:08.726Z
 * 
********************************************************************/
import { ShaderManagerBase } from '../ShaderManagerBase';
import { CompositeShader, CompositeShaderSettings } from './CompositeShader.generated';
import { DecalShader, DecalShaderSettings } from './DecalShader.generated';
import { TestGeometryShader, TestGeometryShaderSettings } from './TestGeometryShader.generated';
import { AdditiveBlendShader, AdditiveBlendShaderSettings } from './AdditiveBlendShader.generated';
import { VolumetricLightShader, VolumetricLightShaderSettings } from './VolumetricLightShader.generated';
import { TextureOverlayShader, TextureOverlayShaderSettings } from './TextureOverlayShader.generated';
import { SkyBoxShader, SkyBoxShaderSettings } from './SkyBoxShader.generated';


export class ShaderManager extends ShaderManagerBase {

   public getCompositeShader(...settings: CompositeShaderSettings) : CompositeShader {
        return super.getShader('CompositeShader', settings, () => new CompositeShader(this.gl, settings)) as CompositeShader;
    }
   public getDecalShader(...settings: DecalShaderSettings) : DecalShader {
        return super.getShader('DecalShader', settings, () => new DecalShader(this.gl, settings)) as DecalShader;
    }
   public getTestGeometryShader(...settings: TestGeometryShaderSettings) : TestGeometryShader {
        return super.getShader('TestGeometryShader', settings, () => new TestGeometryShader(this.gl, settings)) as TestGeometryShader;
    }
   public getAdditiveBlendShader(...settings: AdditiveBlendShaderSettings) : AdditiveBlendShader {
        return super.getShader('AdditiveBlendShader', settings, () => new AdditiveBlendShader(this.gl, settings)) as AdditiveBlendShader;
    }
   public getVolumetricLightShader(...settings: VolumetricLightShaderSettings) : VolumetricLightShader {
        return super.getShader('VolumetricLightShader', settings, () => new VolumetricLightShader(this.gl, settings)) as VolumetricLightShader;
    }
   public getTextureOverlayShader(...settings: TextureOverlayShaderSettings) : TextureOverlayShader {
        return super.getShader('TextureOverlayShader', settings, () => new TextureOverlayShader(this.gl, settings)) as TextureOverlayShader;
    }
   public getSkyBoxShader(...settings: SkyBoxShaderSettings) : SkyBoxShader {
        return super.getShader('SkyBoxShader', settings, () => new SkyBoxShader(this.gl, settings)) as SkyBoxShader;
    }

}
